


































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import ContactDto from "@/models/Contacts/ContactDto";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { LocationDetailsModule } from "@/store/modules/locationDetails";
import CreateContactLocationRequest from "@/models/ContactLocations/CreateContactLocationRequest";
// @ts-ignore

//import { VueTelInputVuetify } from 'vue-tel-input-vuetify';

@Component({
  name: "ContactLocationCreate",
})
export default class extends GiganautVueDialog {

public entity = new ContactDto();

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new ContactDto();
      await LocationDetailsModule.getCompanyContacts();
    }
  }

  get contacts() {
    return LocationDetailsModule.companyContacts;
  }

  get loading() {
    return LocationDetailsModule.loadingDialog;
  }

  async save() {
    const request = new CreateContactLocationRequest();
    request.contactId = this.entity.id;
    await LocationDetailsModule.createContactLocation(request);
    this.dialog = false;
  }
}
